import { h } from 'preact';
import * as BaseComp from 'components/pages/synopsis/synopsis.js';
import * as transitionStates from 'components/core/transition/transitionStates.js';
import s from 'components/pages/synopsis/synopsis.sss';
import HTML from 'components/core/html/html';
import { marked } from 'marked';
import { joinClasses } from 'utils/utils';

export default class Synopsis extends BaseComp.default {

	render({ appData, pageData, transitionState }) {
		const { copy } = appData;
		const { imageSrc, disableSynopsisHeader } = pageData;

		let contentClass = s.contentBox;

		const description = pageData.descriptionCopy ? copy[pageData.descriptionCopy] : copy.$SYNOPSIS_DESCRIPTION;
		const headerCopy = pageData.headerCopy ? copy[pageData.headerCopy] : copy.$SYNOPSIS_HEADER;
		const cast = pageData.castContent ? pageData.castContent : copy.$SYNOPSIS_CAST;
		const descriptionHeader = pageData.descriptionHeader ? pageData.descriptionHeader : copy.$SYNOPSIS;
		const date = pageData.synopsisDate ? pageData.synopsisDate : copy.$SYNOPSIS_DATE;

		const contact = copy.$SYNOPSIS_CONTACT;

		let languageDirection = appData.meta.region.slug === "il";

		marked.setOptions({
			breaks: true,
			smartLists: true
		});


		if (transitionState === transitionStates.STATE_CHILD_ENTERING || transitionState === transitionStates.STATE_CHILD_LEAVING) {
			contentClass = s.contentBoxTransition;
		}

		//!!!!!WARNING!!!!! If you want to do custom styling on the synopsis page,
		// use the s.customContainer class as a wrapper if your override!!!!
		let contentContainer = pageData.customStyling || pageData.includeCast ? s.customContainer : s.contentContainer;

		let paragraphs;
		if (pageData.includeCast) {
			paragraphs = [
				<HTML class={s.castDescription} content={description} markdown />,
				<HTML class={joinClasses(s.castDescription, s.contact)} content={contact} markdown />,
				<HTML class={s.castContent} content={cast} markdown />
			];
		} else {
			let header;
			if (!imageSrc && !disableSynopsisHeader) {
				header = <h1 class={s.synopsisHeader}>{descriptionHeader}</h1>;
			}
			paragraphs = (
				<div class={s.description}>
					{header}
					<HTML content={description} markdown />
				</div>
			);
		}

		return (
			<div class={contentClass}>
				<div class={contentContainer}>
					{this.getTitleTreatment()}
					<HTML class={s.header} content={headerCopy} markdown />
					<HTML class={s.synopsisDate} content={date} markdown />
					<bdo class={s.paragraphs} dir={languageDirection ? "rtl" : "ltr"}>
						{paragraphs}
					</bdo>
					{this.getExtraContent()}
				</div>
				<div class={s.contentOutside}>{this.getContentOutside()}</div>
			</div>
		);

	}
}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
